module["exports"] = [
  "021 ### #####",
  "031 ### #####",
  "041 ### #####",
  "045 ### #####",
  "061 ### #####",
  "051 ### #####",
  "058 ### #####",
  "028 ### #####",
  "026 ### #####",
  "044 ### #####",
  "024 ### #####",
  "023 ### #####",
  "076 ### #####",
  "+98 21 ### #####"
];



















//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/fa/phone_number/formats.js
// module id = 2905
// module chunks = 1609